import { useEffect, useRef, useState } from "react";

import { CoreServices } from "../base/service/apiServices";
import { MainLayout } from "../components/mainpage";
import { shortcutKeyActions } from "../store/slices/shortcutkeys_slice/shortcutkeys_slice";
import { useDispatcher } from "../custom_hooks/use_app_dispatch";
import { useHotkeys } from "react-hotkeys-hook";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { supervisorContactDataSliceActions } from "../store/slices/supervisor_contact/contactsData";
import { CustomQueueActions } from "../store/slices/custom_queue_slice/custom_queue_slice";

function ShortCutKeys(props: any) {
  const notificationRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatcher();
  const [data, setData] = useState<any>([]);
  const [defaultData, setDefaultData] = useState<any>([]);
  const navigate = useNavigate();
  const shortcutKeysSlice = useSelector((state: any) => state.shortcutKeys);
  const [shortcutKeyVal, setShortCutKeyVal] = useState<any>({
    isOpen: false,
    isOpenKeyName: "",
  });
  const [agentTrackerProps, setAgentTrackerProps] = useState<any>();
  const [propsValue, setPropsValue] = useState<any>();
  const [defaultShortKeys, setDefaultShortKeys] = useState<any>([]);
  const {
    set_array
  } = useSelector((store: any) => store.supervisorContactData);
  const [editColumns, setEditColumns] = useState(false);
  const [shortKeys, setShortKeys] = useState<any>({
    myActivity: {
      key1: "",
      key2: "",
      key3: "",
    },
    allActivity: {
      key1: "",
      key2: "",
      key3: "",
    },
    contacts: {
      key1: "",
      key2: "",
      key3: "",
    },
    holdCall: {
      key1: "",
      key2: "",
    },
    playPrompt: {
      key1: "",
      key2: "",
    },
    createPlayPrompt: {
      key1: "",
      key2: "",
      key3: "",
    },
    transferCall: {
      key1: "",
      key2: "",
    },
    leaveConference: {
      key1: "",
      key2: "",
    },
    customQueue: {
      key1: "",
      key2: "",
    },
    callBack: {
      key1: "",
      key2: "",
    },

    createCustomQueue: {
      key1: "",
      key2: "",
      key3: "",
    },
    analytics: {
      key1: "",
      key2: "",
      key3: "",
    },
    agentStatus: {
      key1: "",
      key2: "",
    },
    createDispositionStatus: {
      key1: "",
      key2: "",
      key3: "",
    },
    reports: {
      key1: "",
      key2: "",
      key3: "",
    },
    createAgentStatus: {
      key1: "",
      key2: "",
      key3: "",
    },
    routingProfile: {
      key1: "",
      key2: "",
    },
    bussinessHours: {
      key1: "",
      key2: "",
    },
    webChatConfig: {
      key1: "",
      key2: "",
    },
    skillManagement: {
      key1: "",
      key2: "",
    },

    createBussinessHours: {
      key1: "",
      key2: "",
      key3: "",
    },
    customerType: {
      key1: "",
      key2: "",
      key3: "",
    },
    dashboard: {
      key1: "",
      key2: "",
      key3: "",
    },
    createChatWidget: {
      key1: "",
      key2: "",
      key3: "",
    },
    createRoutingProfile: {
      key1: "",
      key2: "",
      key3: "",
    },
    dispositionStatus: {
      key1: "",
      key2: "",
    },
    createCustomerType: {
      key1: "",
      key2: "",
      key3: "",
    },
    createSkillManagement: {
      key1: "",
      key2: "",
      key3: "",
    },
    bellNotification: {
      key1: "",
      key2: "",
    },
    globalSearch: {
      key1: "",
      key2: "",
    },
    newCustomer: {
      key1: "",
      key2: "",
    },
    goAgentTracker: {
      key1: "",
      key2: "",
    },
    answerCall: {
      key1: "",
      key2: "",
    },
    declineCall: {
      key1: "",
      key2: "",
    },
    hangCall: {
      key1: "",
      key2: "",
    },
    muteAndUnmute: {
      key1: "",
      key2: "",
    },
    logOut: {
      key1: "",
      key2: "",
    },
    readyState: {
      key1: "",
      key2: "",
    },
    notReady: {
      key1: "",
      key2: "",
    },
    transfer: {
      key1: "",
      key2: "",
    },
    away: {
      key1: "",
      key2: "",
    },
    offline: {
      key1: "",
      key2: "",
    },
  });
  const [isWindows, setIsWindows] = useState<boolean>(true);

  useEffect(() => {
    getInitialValue();
    getDefaultInitialVal();

    // defaultShort()
  }, [shortcutKeysSlice.isUpdate]);

  useEffect(() => {
    if (navigator.userAgent.indexOf("Mac OS X") != -1) {
      setIsWindows(true);
    } else {
      setIsWindows(false);
    }
  }, []);

  const checkDeviceType = () => {
    if (navigator.userAgent.indexOf("Mac OS X") != -1) {
      setIsWindows(true);
    } else {
      setIsWindows(false);
    }
  };

  //fixedKey values
  useHotkeys(`Ctrl+S`, (e: any) => {
    if (defaultShortKeys?.globalSearch?.status === 1) {
      if (!isWindows) {
        e.preventDefault();
        let key: any = document.getElementById("mytext") as HTMLInputElement;
        key?.focus();
        dispatch(
          shortcutKeyActions.propsValue({
            globalSearch: true,
          })
        );
      }
    }
  });
  useHotkeys(`Meta+S`, (e: any) => {
    if (defaultShortKeys?.globalSearch?.status === 1) {
      if (navigator.userAgent.indexOf("Mac OS X") != -1) {
        e.preventDefault();
        let key: any = document.getElementById("mytext") as HTMLInputElement;
        key?.focus();
        dispatch(
          shortcutKeyActions.propsValue({
            globalSearch: true,
          })
        );
      }
    }
  });
  useHotkeys("Alt+C", (e: any) => {
    if (defaultShortKeys.newCustomer.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          createCustomer: true,
        })
      );
      // return <CreateForm open={true}/>
      navigate("/contactscreen");

      // dispatch(
      //   shortcutKeyActions.setOpenUpdateForm({
      //     open: true,
      //     coid: "",
      //     edit_create: "edit",
      //   })
      // );

      // dispatch(supervisorContactDataSliceActions.setFormData({}));
      // CreateForm()
    }
  });
  useHotkeys(`Alt+T`, (e: any) => {
    if (defaultShortKeys.goAgentTracker.status === 1) {
      e.preventDefault();
      setAgentTrackerProps(true);
      dispatch(
        shortcutKeyActions.propsValue({
          agentTracker: true,
        })
      );
    }
  });
  useHotkeys(`Shift+A`, (e: any) => {
    if (defaultShortKeys.answerCall.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          answerIncomingCall: true,
        })
      );
    }
  });
  useHotkeys(`Shift+D`, (e: any) => {
    if (defaultShortKeys.declineCall.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          declineIncomingCall: true,
        })
      );
    }
  });
  useHotkeys(`Shift+H`, (e: any) => {
    if (defaultShortKeys.hangCall.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          hangCall: true,
        })
      );
    }
  });
  useHotkeys(`Ctrl+M`, (e: any) => {
    if (!isWindows) {
      if (defaultShortKeys.muteAndUnmute.status === 1) {
        e.preventDefault();
        dispatch(
          shortcutKeyActions.propsValue({
            muteUnmute: true,
          })
        );
      }
    }
  });
  useHotkeys(`Meta+M`, (e: any) => {
    if (navigator.userAgent.indexOf("Mac OS X") != -1) {
      if (defaultShortKeys.muteAndUnmute.status === 1) {
        e.preventDefault();
        dispatch(
          shortcutKeyActions.propsValue({
            muteUnmute: true,
          })
        );
      }
    }
  });
  useHotkeys(`Alt+Q`, (e: any) => {
    if (defaultShortKeys.logOut.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          logOut: true,
        })
      );
    }
  });
  useHotkeys(`Alt+R`, (e: any) => {
    if (defaultShortKeys.readyState.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          readyState: true,
        })
      );
    }
  });
  useHotkeys(`Alt+N`, (e: any) => {
    if (defaultShortKeys.notReady.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          notReady: true,
        })
      );
    }
  });
  useHotkeys(`Shift+T`, (e: any) => {
    if (defaultShortKeys.transfer.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          transferOnly: true,
        })
      );
    }
  });
  useHotkeys(`Alt+A`, (e: any) => {
    if (defaultShortKeys.away.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          away: true,
        })
      );
    }
  });
  useHotkeys(`Alt+O`, (e: any) => {
    if (defaultShortKeys.offline.status === 1) {
      e.preventDefault();
      dispatch(
        shortcutKeyActions.propsValue({
          offline: true,
        })
      );
    }
  });

  //dynamic key values
  useHotkeys(`${shortKeys.allActivity.key1}+${shortKeys.allActivity.key2}+${shortKeys.allActivity.key3}`, (e: any) => {
    if (shortKeys.allActivity.status === 1) {
      e.preventDefault();
      navigate("/AllActivity");
    }
  });
  useHotkeys(`${shortKeys.analytics.key1}+${shortKeys.analytics.key2}+${shortKeys.analytics.key3}`, (e: any) => {
    if (shortKeys.analytics.status === 1) {
      e.preventDefault();
      navigate("/reportsmain");
    }
  });
  useHotkeys(`${shortKeys.skillManagement.key1}+${shortKeys.skillManagement.key2}`, (e: any) => {
    if (shortKeys.skillManagement.status === 1) {
      e.preventDefault();
      navigate("/skillmanagement");
    }
  });
  useHotkeys(`${shortKeys.agentStatus.key1}+${shortKeys.agentStatus.key2}`, (e: any) => {
    if (shortKeys.agentStatus.status === 1) {
      e.preventDefault();
      navigate("/agentstatus");
    }
  });
  useHotkeys(
    `${shortKeys.bellNotification.key1}+${shortKeys.bellNotification.key2}`,
    (e) => {
      
      dispatch(shortcutKeyActions.setIsBellModalOpen(true));
      if (shortKeys.bellNotification.status === 1) {
        e.preventDefault();
        notificationRef.current?.click();
      }
    },
    [shortKeys.bellNotification.status]

  );
  

  useHotkeys(`${shortKeys.bussinessHours.key1}+${shortKeys.bussinessHours.key2}`, (e: any) => {
    if (shortKeys.bussinessHours.status === 1) {
      e.preventDefault();
      navigate("/businesshours/list");
    }
  });
  useHotkeys(`${shortKeys.callBack.key1}+${shortKeys.callBack.key2}`, (e: any) => {
    if (!isWindows) {
      if (shortKeys.callBack.status === 1) {
        e.preventDefault();
        // navigate('/businesshours/list')
      }
    }
  });
  useHotkeys(`Meta+${shortKeys.callBack.key2}`, (e: any) => {
    if (navigator.userAgent.indexOf("Mac OS X") != -1) {
      if (shortKeys.callBack.status === 1) {
        e.preventDefault();
        // navigate('/businesshours/list')
      }
    }
  });
  useHotkeys(`${shortKeys.contacts.key1}+${shortKeys.contacts.key2}+${shortKeys.contacts.key3}`, (e: any) => {
    if (shortKeys.contacts.status === 1) {
      e.preventDefault();
      navigate("/contactscreen");
    }
  });
  useHotkeys(`${shortKeys.createAgentStatus.key1}+${shortKeys.createAgentStatus.key2}+${shortKeys.createAgentStatus.key3}`, (e: any) => {
    if (shortKeys.createAgentStatus.status === 1) {
      e.preventDefault();
      navigate("/agentdetails/create");
    }
  });
  useHotkeys(`${shortKeys.createBussinessHours.key1}+${shortKeys.createBussinessHours.key2}+${shortKeys.createBussinessHours.key3}`, (e: any) => {
    if (shortKeys.createBussinessHours.status === 1) {
      e.preventDefault();
      navigate("/businesshours/create");
    }
  });
  useHotkeys(`${shortKeys.createChatWidget.key1}+${shortKeys.createChatWidget.key2}+${shortKeys.createChatWidget.key3}`, (e: any) => {
    if (shortKeys.createChatWidget.status === 1) {
      e.preventDefault();
      navigate("webchatwidget/configuration");
    }
  });
  useHotkeys(`${shortKeys.createCustomQueue.key1}+${shortKeys.createCustomQueue.key2}+${shortKeys.createCustomQueue.key3}`, (e: any) => {
    if (!isWindows) {
      if (shortKeys.createCustomQueue.status === 1) {
        e.preventDefault();
        navigate("/customqueue");
      }
    }
  });
  useHotkeys(`Meta+${shortKeys.createCustomQueue.key2}+${shortKeys.createCustomQueue.key3}`, (e: any) => {
    if (navigator.userAgent.indexOf("Mac OS X") != -1) {
      if (shortKeys.createCustomQueue.status === 1) {
        e.preventDefault();
        navigate("/customqueue");
      }
    }
  });
 
  useHotkeys(`${shortKeys.createCustomerType.key1}+${shortKeys.createCustomerType.key2}+${shortKeys.createCustomerType.key3}`, (e: any) => {
    if (shortKeys.createCustomerType.status === 1) {
      e.preventDefault();
      dispatch(CustomQueueActions.setIsCreateCustomerModalOpen(true));
      navigate('/customertype');
    }
  });

  // useHotkeys(
  //   "alt+w",
  //   (e) => {
  //     console.log("Hotkey triggered");
  //     e.preventDefault();
  //     navigate('/webchatwidget/configuration');
  //   },
  //   [],
  //   []
  // );

  useHotkeys(`${shortKeys.createDispositionStatus.key1}+${shortKeys.createDispositionStatus.key2}+${shortKeys.createDispositionStatus.key3}`, (e: any) => {
    if (shortKeys.createDispositionStatus.status === 1) {
      e.preventDefault();
      navigate("/dispositionstatus");
    }
  });
  useHotkeys(`${shortKeys.createPlayPrompt.key1}+${shortKeys.createPlayPrompt.key2}+${shortKeys.createPlayPrompt.key3}`, (e: any) => {
    if (shortKeys.createPlayPrompt.status === 1) {
      e.preventDefault();
      navigate("/playprompt");
    }
  });
  useHotkeys(`${shortKeys.createRoutingProfile.key1}+${shortKeys.createRoutingProfile.key2}+${shortKeys.createRoutingProfile.key3}`, (e: any) => {
    if (shortKeys.createRoutingProfile.status === 1) {
      e.preventDefault();
      navigate("/routingprofile/create");
    }
  });
  useHotkeys(`${shortKeys.createSkillManagement.key1}+${shortKeys.createSkillManagement.key2}+${shortKeys.createSkillManagement.key3}`, (e: any) => {
    if (shortKeys.createSkillManagement.status === 1) {
      e.preventDefault();
      navigate("/skillmanagement");
    }
  });
  useHotkeys(`${shortKeys.customQueue.key1}+${shortKeys.customQueue.key2}`, (e: any) => {
    if (!isWindows) {
      if (shortKeys.customQueue.status === 1) {
        e.preventDefault();
        navigate("/customqueue/list");
      }
    }
  });
  useHotkeys(`Meta+${shortKeys.customQueue.key2}`, (e: any) => {
    if (navigator.userAgent.indexOf("Mac OS X") != -1) {
      if (shortKeys.customQueue.status === 1) {
        e.preventDefault();
        navigate("/customqueue/list");
      }
    }
  });
  useHotkeys(`${shortKeys.customerType.key1}+${shortKeys.customerType.key2}+${shortKeys.customerType.key3}`, (e: any) => {
    if (shortKeys.customerType.status === 1) {
      e.preventDefault();
      // navigate('/skillmanagement')
    }
  });
  useHotkeys(`${shortKeys.dashboard.key1}+${shortKeys.dashboard.key2}+${shortKeys.dashboard.key3}`, (e: any) => {
    if (shortKeys.dashboard.status === 1) {
      e.preventDefault();
      navigate("/AgentdashBoard");
    }
  });
  useHotkeys(`${shortKeys.dispositionStatus.key1}+${shortKeys.dispositionStatus.key2}`, (e: any) => {
    if (shortKeys.dispositionStatus.status === 1) {
      e.preventDefault();
      navigate("/dispositionstatus");
    }
  });
  useHotkeys(`${shortKeys.holdCall.key1}+${shortKeys.holdCall.key2}`, (e: any) => {
    if (shortKeys.holdCall.status === 1) {
      e.preventDefault();
      // navigate('/dispositionstatus')
    }
  });
  useHotkeys(`${shortKeys.leaveConference.key1}+${shortKeys.leaveConference.key2}`, (e: any) => {
    if (shortKeys.leaveConference.status === 1) {
      e.preventDefault();
      // navigate('/dispositionstatus')
    }
  });
  useHotkeys(`${shortKeys.myActivity.key1}+${shortKeys.myActivity.key2}+${shortKeys.myActivity.key3}`, (e: any) => {
    if (shortKeys.myActivity.status === 1) {
      e.preventDefault();
      navigate("/myactivity");
    }
  });
  useHotkeys(`${shortKeys.playPrompt.key1}+${shortKeys.playPrompt.key2}`, (e: any) => {
    if (shortKeys.playPrompt.status === 1) {
      e.preventDefault();
      navigate("/playprompt");
    }
  });
  useHotkeys(`${shortKeys.reports.key1}+${shortKeys.reports.key2}+${shortKeys.reports.key3}`, (e: any) => {
    if (shortKeys.reports.status === 1) {
      e.preventDefault();
      navigate('/reportsmain')
    }
  });
  useHotkeys(`${shortKeys.routingProfile.key1}+${shortKeys.routingProfile.key2}`, (e: any) => {
    if (shortKeys.routingProfile.status === 1) {
      e.preventDefault();
      navigate("/routingprofile");
    }
  });
  useHotkeys(`${shortKeys.skillManagement.key1}+${shortKeys.skillManagement.key2}`, (e: any) => {
    if (shortKeys.skillManagement.status === 1) {
      e.preventDefault();
      navigate("/skillmanagement");
    }
  });
  useHotkeys(`${shortKeys.transferCall.key1}+${shortKeys.transferCall.key2}`, (e: any) => {
    if (shortKeys.transferCall.status === 1) {
      e.preventDefault();
      // navigate('/skillmanagement')
    }
  });
  useHotkeys(`${shortKeys.webChatConfig.key1}+${shortKeys.webChatConfig.key2}`, (e: any) => {
    if (shortKeys.webChatConfig.status === 1) {
      e.preventDefault();
      navigate("/webchatwidget/configuration");
    }
  });

  //shortcutKeyModule

  useHotkeys(`Alt+Z`, (e: any) => {
    e.preventDefault();
    navigate("/shortcutkeys");
  });

  const handleShortDatas = (data: any) => {
    const resultArray: any = {};
    data.map((datas: any, index: any) => {
      if (datas.function === "My Activity tab") {
        resultArray["myActivity"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     myActivity: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "All Activity tab") {
        resultArray["allActivity"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     allActivity: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Contacts") {
        resultArray["contacts"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     contacts: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Hold the call") {
        resultArray["holdCall"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     holdCall: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "Transfer the call") {
        resultArray["transferCall"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     transferCall: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "Callback") {
        resultArray["callBack"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     callBack: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "Leave Conference Call") {
        resultArray["leaveConference"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     leaveConference: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "Custom Queue") {
        resultArray["customQueue"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     customQueue: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "Create Custom Queue") {
        resultArray["createCustomQueue"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createCustomQueue: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Prompt Library") {
        resultArray["playPrompt"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     playPrompt: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "Create Prompt Library") {
        resultArray["createPlayPrompt"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createPlayPrompt: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Skill Management") {
        resultArray["skillManagement"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     skillManagement: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "Create Skill Management") {
        resultArray["createSkillManagement"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createSkillManagement: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Business Hours") {
        resultArray["bussinessHours"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     bussinessHours: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "Routing Profile") {
        resultArray["routingProfile"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     routingProfile: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "To Create Business Hours") {
        resultArray["createBussinessHours"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createBussinessHours: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Webchat Configuration") {
        resultArray["webChatConfig"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     webChatConfig: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "To Create Chat widget") {
        resultArray["createChatWidget"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createChatWidget: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "To Create Routing Profile") {
        resultArray["createRoutingProfile"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createRoutingProfile: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Agent Status") {
        resultArray["agentStatus"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     agentStatus: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "To Create Agent Status") {
        resultArray["createAgentStatus"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createAgentStatus: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Disposition Status") {
        resultArray["dispositionStatus"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     dispositionStatus: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
      if (datas.function === "To Create Disposition Status") {
        resultArray["createDispositionStatus"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createDispositionStatus: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Customer Type") {
        resultArray["customerType"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     customerType: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "To Create Customer Type") {
        resultArray["createCustomerType"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     createCustomerType: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Analytics") {
        resultArray["analytics"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     analytics: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Dashboard") {
        resultArray["dashboard"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     dashboard: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Reports") {
        resultArray["reports"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     reports: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, key3: datas.keyValues.key3, status: datas.status },
        // }));
      }
      if (datas.function === "Bell Notification") {
        resultArray["bellNotification"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({
        //     ...shortKeys,
        //     bellNotification: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status }
        // }));
      }
    });
    setShortKeys({ ...shortKeys, ...resultArray });
  };

  const setDefaultShortDatas = (data: any) => {
    const resultArray1: any = {};
    data?.map((datas: any, index: any) => {
      if (datas.function === "Global Search") {
        resultArray1["globalSearch"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, globalSearch: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Go To Agent Tracker") {
        resultArray1["goAgentTracker"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, goAgentTracker: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Create New Customer") {
        resultArray1["newCustomer"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, newCustomer: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Hang-up Call") {
        resultArray1["hangCall"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, hangCall: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Mute and Unmute the call") {
        resultArray1["muteAndUnmute"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, muteAndUnmute: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Decline Incoming call") {
        resultArray1["declineCall"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, declineCall: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Transfer Only") {
        resultArray1["transfer"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, transfer: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Answer Incoming call") {
        resultArray1["answerCall"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, answerCall: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Offline") {
        resultArray1["offline"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, offline: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Ready State") {
        resultArray1["readyState"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, readyState: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Logout") {
        resultArray1["logOut"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, logOut: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Away") {
        resultArray1["away"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, away: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
      if (datas.function === "Not Ready") {
        resultArray1["notReady"] = { ...datas.keyValues, status: datas.status };
        // setShortKeys((shortKeys: any) => ({ ...shortKeys, notReady: { key1: datas.keyValues.key1, key2: datas.keyValues.key2, status: datas.status } }));
      }
    });
    setDefaultShortKeys({ ...defaultShortKeys, ...resultArray1 });
  };

  const getInitialValue = () => {
    CoreServices.get(`/get_shortcut_keys`).then((res: any) => {
      if (res && res.data.statusCode === 200 && res.data.result.length > 0) {
        setData(JSON.parse(res.data.result[0].keyValues));
        handleShortDatas(JSON.parse(res.data.result[0].keyValues));
      }
    }).catch((error: any)=> {
      console.log(error);
    });;
  };

  const getDefaultInitialVal = () => {
    CoreServices.get(`/get_global_shortcut_keys`).then((res: any) => {
      if (res && res.data.statusCode === 200 && res.data.message !== "No data found") {
        setDefaultData(JSON.parse(res.data.result[0].keyValues));
        setDefaultShortDatas(JSON.parse(res.data.result[0].keyValues));
      }
    }).catch((error: any)=> {
      console.log(error);
    });
  };

  return <></>;
}
export default ShortCutKeys;
